import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

const IOS_URL = "https://apps.apple.com/ie/app/walk-ecanvasser/id920020242";
const ANDROID_URL =
    "https://play.google.com/store/apps/details?id=com.vconnecta.ecanvasser.us";

type Platform = "ios" | "android" | "both";

let QrAppDownload = {
    selector: "vcQrAppDownload",
    templateUrl: "/angular/components/qr-code/qr-app-download.component.html",
    bindings: {},
    controller: class QrAppDownloadController {
        public platform: Platform = "both";
        public readonly iosUrl: string = IOS_URL;
        public readonly androidUrl: string = ANDROID_URL;

        private readonly dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit(): void {
            this.platform = QrAppDownloadController.detectPlatform(
                navigator.userAgent || ""
            );
        }

        // Show the store relevant to the device; fall back to both on desktop
        // or anything we can't classify.
        static detectPlatform(userAgent: string): Platform {
            if (/android/i.test(userAgent)) {
                return "android";
            }
            if (/iphone|ipad|ipod/i.test(userAgent)) {
                return "ios";
            }
            return "both";
        }

        close(): void {
            this.dialog.hide();
        }
    },
};

angular.module("qrCode", []).component(QrAppDownload.selector, QrAppDownload);
